
import React, { Component } from "react";
import { HStack} from "@chakra-ui/react";

import CreatableSelect from "react-select/creatable";




const createOption = (label) => ({
    label,
    value: label,
});

const components = {
    DropdownIndicator: null
};


export default class MultiEntryInput extends Component 
{
    constructor(props) {
        super(props);

        this.state = {
            valid: true,
            inputValue: "",
            value: [],
            descript: ""
        }

    }

    componentDidMount()
    {
        if (this.props.cardValue)
        {
            var newValue = this.props.cardValue.map((v) => {return createOption(v)});
            this.setState({value: newValue});
        }
    }




    handleChange = (value, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            let tagValue = actionMeta.removedValue.value;
            this.props.onValueRemove(this.toTagId(tagValue));
        }
        var returnValue = [];
        if (value) {
            returnValue = value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(returnValue);
        //this.props.onValueChange(this.toTagId(), returnValue);
        //this.onValidityCheck(this.state.enabled, returnValue);

        //this.setState({ value });

    };

    handleInputChange = (inputValue) => {
        this.setState({ inputValue });
    };


    handleKeyDown = (event) => {
        if (!this.state.inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                this.setValue(this.state.inputValue);
                this.setInputValue('');
                event.preventDefault();
        }
        var tempVal;
        if (this.state.value) {
            tempVal = this.state.value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(tempVal);
    };


    setValue(val) {
        console.log(typeof (val))
        var newValArray
        if (typeof (val) === "string") {
            var newVal = createOption(val)
            newValArray = this.state.value
            newValArray.push(newVal)
        } else {
            newValArray = val
        }
        this.setState({
            value: newValArray
        })

        // this is returning an array of key Option objects (label, value pairs)

        // this.props.onValueChange(this.state.value);
    }

    setInputValue(val) {
        this.setState({
            inputValue: val
        })
    }


    render() {
        const { inputValue, value } = this.state;
        return (
            <HStack >

                <CreatableSelect
                    
                    autoFocus
                    components={components}
                    inputValue={inputValue}
                    // options={formattedOptions}
                    isClearable
                    isMulti
                    menuIsOpen={false}
                    // isDisabled={false}
                    onChange={(newValue) => this.setValue(newValue)}
                    onInputChange={(newValue) => this.setInputValue(newValue)}
                    onKeyDown={this.handleKeyDown}
                    placeholder="Type Tag and Press Enter"
                    value={this.state.value}

                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            minHeight: '30px',
                            width: '-webkit-fill-available',
                            marginRight: '10px'
                        }),
                        valueContainer: (baseStyles, state) => ({
                            ...baseStyles,
                            fontSize: '16px',
                            marginBottom: '10px'
                        }),
                        container: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '100%'
                        })
                    }}
                />
            </HStack>
        );
    }
}







